import { Link } from "react-router-dom";
import styled from "styled-components";

export const CategoryPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;
export const Title = styled(Link)`
  font-size: 28px;
  margin-bottom: 25px;
  cursor: pointer;
`;

export const Preview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 490px) {
    grid-template-columns: repeat(1, 1fr);
    width: 70%;
    margin: auto;
  }
  @media (max-width: 420px) {
    grid-template-columns: repeat(1, 1fr);
    width: 85%;
    margin: auto;
  }
  @media (max-width: 340px) {
    grid-template-columns: repeat(1, 1fr);
    width: 95%;
    margin: auto;
  }
`;
